import { useAtomValue, useSetAtom } from 'jotai';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { hideNavbarAtom, navbarOpenAtom, onTestPageAtom } from '~/atoms/atoms';
import TestView from '~/components/test/TestView';
import { queryParamToString } from '~/logic/query-param';

// We split the out from the TestView component to ensure that the test is loading.
// This helps with the form's `initalValues`
export default function Test() {
  const router = useRouter();
  const testId = queryParamToString(router.query.testId);

  const hideNavbar = useAtomValue(hideNavbarAtom);
  const setNavbarOpen = useSetAtom(navbarOpenAtom);
  const setOnTestPage = useSetAtom(onTestPageAtom);

  useEffect(() => {
    setNavbarOpen(false);
    setOnTestPage(true);

    return () => {
      setNavbarOpen(!hideNavbar);
      setOnTestPage(false);
    };
  }, [setNavbarOpen, setOnTestPage, hideNavbar]);

  return <TestView testId={testId} />;
}
